import type { IProjectSample } from '../../../Model/Project/IProjectSample.js'

export interface AddSamplesGate {
  samples: IProjectSample[] | 'LOADING'
  samplesLoading: boolean
  locked: boolean
  adding: boolean
}

/** Why "Add Samples" is unavailable, or `undefined` when it may be used. */
export const addSamplesDisabledReason = ({ samples, samplesLoading, locked, adding }: AddSamplesGate): string | undefined => {
  if (adding) return 'Samples are still being added to this project'
  if (locked) return 'Project data is refreshing, please wait'
  if (samples === 'LOADING' || samplesLoading) return "Waiting for the project's samples to load"
  return undefined
}
